import { Box, Button, Container, Flex, FormControl, FormErrorMessage, FormLabel, Input, Select, Text, useToast } from '@chakra-ui/react'
import { useFormik } from 'formik'
import { HiArrowNarrowLeft } from 'react-icons/hi'
import { useNavigate } from 'react-router-dom'
import AdminHelpers from '../../../services/admin/admin.service'
import Adminroutes from '../routes'

const NewRole = () => {
    const navigate = useNavigate();
    const authorisation_levels = ['Enterprise', 'State'];
    const toast = useToast();

    const formik = useFormik({
        validate: (values: any) => {
            const errors: any = {};
            if (!values.name) {
                errors.name = 'Name is required'
            }
            if (!values.description) {
                errors.description = 'Authorisation level is required'
            }

            return errors;
        },
        initialValues: {
            name: '',
            description: '',

        },
        onSubmit: async(values)=> {
            const newRoleInfo: any ={
                name: values.name,
                descrption: values.description
            }
            try {
                const newInfoRes = await AdminHelpers.createRole(newRoleInfo);
                if (newInfoRes.status === 'success') {
                    
                    toast({
                        title: "Role",
                        description: 'Role created',
                        status: "success",
                    })
                    formik.resetForm()
                    navigate(-1)
                }
            } catch (error: any) {
                toast({
                    title: "Role",
                    description: `${error.response.data.message}`,
                    status: "error",
                })
            }
        }
    })

  return (
    <Box minHeight="100vh" pb="30px" bg="#F9F8F8" >
            <Container
                width={{lg:"40%", md:'80%', sm:'95%', base:'95%'}}
                maxWidth={"84%"}
                px={0}
                pt='100px'
                right={0}
                bg="F9F8F8"
                mx='auto'
            >
                <Box
                    mb='60px'
                    display="flex"
                    alignItems="center"
                    border="1px solid #616161"
                    padding={'5px 12px'}
                    width="fit-content"
                    borderRadius="5px"
                    cursor="pointer"
                >
                    <HiArrowNarrowLeft color="#616161" fontSize="20px" />
                    <Text fontSize="14px" color="#616161" pl="5px" onClick={() => navigate(Adminroutes.Roles)} fontWeight={700}>
                        Back to Roles
                    </Text>
                </Box>
                <Box bg='white' px='40px' py='60px' boxShadow="sm" rounded="lg" height="auto" mb="30px">
                    <Text fontWeight='700' fontSize='24px' color='#1E1E1E'>New Role</Text>
                    <Box mt={4}>
                        <form onSubmit={formik.handleSubmit} >
                            <FormControl mt={6} mb="1rem" isInvalid={(formik.errors.name && formik.touched.name) ? true : false}>
                                <FormLabel fontWeight="normal" color="brand.3" mb='12px' fontSize={"14px"}>Role name</FormLabel>
                                <Input
                                    type="text"
                                    id="name"
                                    name="name"
                                    placeholder="Enter role name"
                                    onChange={formik.handleChange}
                                    fontSize={13}
                                    value={formik.values.name}
                                    height="2.2rem"
                                    borderColor={'#D5D5D5'}
                                />
                                <FormErrorMessage fontSize={12} >{formik.errors.name}</FormErrorMessage>
                            </FormControl>
                            <FormControl mb='1rem' color="brand.3" isInvalid={(formik.errors.description && formik.touched.description) ? true : false}>
                                <FormLabel fontWeight="normal"  color="brand.3" fontSize='14px' mb='12px'>User Authorization Level</FormLabel>
                                <Select variant="outline" height="2.2rem" bg="inputText.500" size="sm" placeholder="Select authorisation level" value={formik.values.description} name="description" onChange={formik.handleChange} fontSize='14px' borderColor={'#D5D5D5'}>
                                    {
                                        authorisation_levels.map((each, index) => (<option key={index} value={each}> {each} </option>)
                                        )
                                    }
                                </Select>
                                <FormErrorMessage fontSize={12} >{formik.errors.description}</FormErrorMessage>
                            </FormControl>
                            <Flex mt={12} justifyContent="flex-end">
                                <Button
                                    colorScheme="red"
                                    type="submit"
                                    isLoading={formik.isSubmitting}
                                    onClick={() => { formik.handleSubmit() }}
                                    size="sm"
                                    px={4}
                                    py={4}
                                    fontSize={14}
                                    borderRadius={'4px'}
                                >CREATE ROLE</Button>
                            </Flex>
                        </form>
                    </Box>
                </Box>
            </Container>
    </Box>
  )
}

export default NewRole
